// @ts-nocheck
import { Fragment } from "react";
import withPageAllowedRules from "./withPageAllowedRules";
import PageTitle from "../components/PageTitle/PageTitle";

import DevicesListPageContainer from "../components/Devices/DevicesListPageContainer";

const DevicesListPage = ({ group }) => (
  <Fragment>
    <PageTitle id="Menu@devices">Dispositivos</PageTitle>
    <DevicesListPageContainer group={group} />
  </Fragment>
);

export default withPageAllowedRules({
  component: DevicesListPage,
  pageAllowedRule: "devices",
});
